import { render, staticRenderFns } from "./AudiobooksPage.vue?vue&type=template&id=a8847b26&scoped=true&"
import script from "./AudiobooksPage.vue?vue&type=script&lang=ts&"
export * from "./AudiobooksPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8847b26",
  null
  
)

export default component.exports